
export const viewOptions = {
  studyProgrammeComparison: '/erialad/võrdlus',
  oskaProfessionsComparison: '/ametialad/võrdlus',
  curriculaComparison: '/erialad/võrdlus'
}
export const maxItems = {
  studyProgrammeComparison: 3,
  oskaProfessionsComparison: 3,
  curriculaComparison: 3,
  'default': 10
}
export const translationsPerType = {
  studyProgrammeComparison: {
    success: 'studyProgramme.added_to_comparison',
    info: 'studyProgramme.in_comparison',
    title: 'studyProgramme.compare_modal_title',
    content: 'studyProgramme.compare_modal_content',
    viewTitle: 'studyProgramme.label',
    viewSubtitle: 'studyProgramme.compare_modal_title'
  },
  oskaProfessionsComparison: {
    success: 'oskaProfessions.added_to_comparison',
    info: 'oskaProfessions.in_comparison',
    title: 'oskaProfessions.compare_modal_title',
    content: 'oskaProfessions.compare_modal_content',
    viewTitle: 'oskaProfessions.label',
    viewSubtitle: 'oskaProfessions.compare_label',
  },
  curriculaComparison: {
    success: 'curricula.added_to_comparison',
    info: 'curricula.in_comparison',
    title: 'curricula.compare_modal_title',
    content: 'curricula.compare_modal_content',
    viewTitle: 'curricula.label',
    viewSubtitle: 'curricula.compare_modal_title'
  }
}